module.exports = __webpack_public_path__ + "static/eat-pray-money-6ebd0652fd11ce85f8538869cb616b3d.gif";